import { toast } from 'react-toastify';

export const showSuccessToast = message => {
  toast.success(message, {
    className: 'toast-success',
    progressClassName: 'toast-progress-success',
  });
};

export const showErrorToast = message => {
  toast.error(message, {
    className: 'toast-error',
    progressClassName: 'toast-progress-error',
  });
};

export const showInfoToast = message => {
  toast.info(message, {
    className: 'toast-info',
    progressClassName: 'toast-progress-info',
  });
};

export const showWarningToast = message => {
  toast.warning(message, {
    className: 'toast-warning',
    progressClassName: 'toast-progress-warning',
  });
};

export const showWelcomeToast = userName => {
  toast.success(`Welcome back, ${userName}!`, {
    autoClose: 5000,
    className: 'toast-welcome',
  });
};

export const showSignupSuccessToast = userName => {
  toast.success(
    `Welcome to Bookings App, ${userName}! Your account has been created successfully.`,
    {
      autoClose: 6000,
      className: 'toast-welcome',
    }
  );
};

export const showLoadingToast = (message = 'Loading...') => {
  return toast.loading(message, {
    className: 'toast-loading',
  });
};

export const updateToastToSuccess = (toastId, message) => {
  toast.update(toastId, {
    render: message,
    type: 'success',
    isLoading: false,
    autoClose: 4000,
  });
};

export const updateToastToError = (toastId, message) => {
  toast.update(toastId, {
    render: message,
    type: 'error',
    isLoading: false,
    autoClose: 4000,
  });
};
